import { css } from '@emotion/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import ContentPage from '@/src/cms/components/CMSPage/Content';
import { requestStaticContent } from '@/src/cms/utils';

export default function Conferences({ sitepageid, pagedata }) {
  const { isLoggedIn, isLoading } = useSelector(store => store.auth);
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && !isLoggedIn) {
      router.replace('/events/conferences-nonmember');
    }
  }, [isLoggedIn, isLoading, router]);

  if (isLoading) return null;

  return (
    <ContentPage
      sitepageid={sitepageid}
      pagedata={pagedata}
      bypassLogin
      bodyStyle={css`
        .sanitized {
          a {
            display: inline;
          }
          @media (max-width: 768px) {
            table {
              width: 100% !important;
              tr {
                width: 100% !important;
                display: flex;
                flex-direction: column;
                td {
                  width: 100% !important;
                }
              }
            }
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  const sitepageid = 55558;
  const pagedata = await requestStaticContent(sitepageid);
  return {
    props: { sitepageid, pagedata },
  };
}
